/**
 * Is a modal of the HOST page open? (`<dialog open>` / `aria-modal="true"` in the light DOM.)
 * Widget overlays live in the widget's own Shadow DOM, so they never match here.
 */
export function hostModalOpen(): boolean {
  return document.querySelector('dialog[open], [aria-modal="true"]') !== null;
}
